module.exports = __webpack_public_path__ + "static/media/volume-up.4685354d.svg";